// 条件つきの商品（ショップの「限定」。products.ts の offer）：はじめての10連（1アカウント1回）・討伐記念10連（章ボスを初めて倒してから24時間）・
// リリース記念セット（期間まで。中身をどれも持っていないときだけ）。買った数はサーバーが注文の台帳から数えて渡す（Profile には残さない）
import { CONFIG } from './config';
import type { Product } from './products';
import type { Profile } from './profile';

/** 章ボスを初めて倒したとき（通常の難易度）：討伐記念の窓を開ける。窓が残っていても新しいボスから数え直す */
export function openBossOffer(p: Profile, stageId: number, now: number) {
  p.bossOffer = { stage: stageId, from: now, until: now + CONFIG.offers.bossHours * 3_600_000 };
}

/** 注文を数える始まり（boss はその窓の開いた時刻から。ほかは全期間＝0） */
export const offerSince = (product: Product, p: Pick<Profile, 'bossOffer'>) => (product.offer?.kind === 'boss' ? (p.bossOffer?.from ?? 0) : 0);

/**
 * 条件つきの商品の今の状態。条件の無い商品は null。
 * bought＝offerSince からの支払い済み（返金・異議も含む）の注文の数。until＝締め切り（once は無い）。
 * owned＝セットの中身を持っているので買えない（'all' 全部・'some' 一部）。期間中はショップに「購入済み」「一部購入済み」で出す
 */
export function offerState(
  product: Product,
  p: Pick<Profile, 'bossOffer' | 'entitlements'>,
  now: number,
  bought: number,
): { open: boolean; until: number | null; owned?: 'all' | 'some' } | null {
  const o = product.offer;
  if (!o) return null;
  if (product.effect.kind === 'bundle') {
    const have = product.effect.keys.filter((k) => p.entitlements.includes(k)).length;
    const until = o.kind === 'until' ? o.until : null;
    if (have) return { open: false, until: until && until > now ? until : null, owned: have === product.effect.keys.length ? 'all' : 'some' };
  }
  if (o.kind === 'once') return { open: bought === 0, until: null };
  if (o.kind === 'boss') {
    const until = p.bossOffer?.until ?? 0;
    return { open: until > now && bought === 0, until: until > now ? until : null };
  }
  return { open: now < o.until, until: o.until };
}
